import React, { useState } from "react";
import { EBPlayButton } from "./chants/audio/EBPlayButton";
import { EBChant } from "./chants/eb-chant/EBChant";

// (c4) A(e) (c) (ddrdr) M(dh) (hi) (hhrhr) (h) (g) (h) (gf) M(g) (gh) (hhr) (,) (h) (g) (h) (gf) (g) (gh) (hhr) (;) (h) (g) (h) (g) (f) (e) (f) (g) (fe) M(d) (drdr)

const MELODIES = {
    "1a": "(c4) 1(e) 2(c) 3(d) M4(ixdh/iv) 74(dh) 75(ixhi) m6(h) 7(g) 8(h) 9(gf) 10(g) M11(gh) 12(h) 13(,) M41(hg) 42(gh) 14(;) m15(h) 16(g) 17(h) 18(g) 67(hg) 68(hvGF) 19(f) 70(e) 71(f) m72(fg) m20(e) 21(f) m50(ef) 22(g) 23(fe) M24(d)",
    "1b": "(c4) 1(d) M2(dc) 3(f) 4(g) 93(fg) M5(fh) 6(h) 13(,) m86(h) 87(g) 88(h) 89(gf) 810(g) M811(gh) 812(h) M41(hg) 42(gh) 814(;) m15(h) 16(g) 17(h) 18(g) 67(hg) 68(hvGF) 19(f) 70(e) 71(f) m72(fg) 20(e) 21(f) 51(ef) 22(g) 23(fe) M24(d)",
    "2": "(f3) 1(fh) 41(f) 42(h) 2(h) M3(hg) 43(h) 44(g) 4(f) 45(fg) 46(g) 4(f) 5(,) m51(f) 52(gh) 53(fg) m54(f) 55(e) 56(;) 6(f) 7(e) 8(f) 47(ef) M9(h) 10(hg) 410(h) 411(g) M11(fe) 12(f) 13(gh) M14(f)",
    "3": "(c4) 1(g) 31(h) 2(hj) 3(j) m4(jk) 5(j) 6(ji) 32(h) 33(i) m7(h) 8(g) m9(gh) 10(g) 11(;) 12(g) 13(gf) 34(g) 35(f) m14(gh) 15(gf) M16(e)",
    "4": "(c4) 1(e) 2(d) 3(e) 4(g) M5(gh) 75(g) 76(h) 6(h) 7(,) 11(h) 12(g) 13(h) m14(i) 15(h) 16(g) 17(h) 18(,) 21(h) 23(g) 24(f) M25(g) M825(gf) 26(f) 27(e)",
    //"5": "(c3) 1(f) 2(d) 3(f) 41(df) M4(h) 5(gxg) M6(f) 7(gxgh) 8(h) 51(,) 9(h) 10(hi) 11(i) 52(;) 12(h) M13(gxge) 14(f) 15(ef) M16(d) 17(d) 53(:) 31(d) 32(e) 33(f) 34(ef) 35(d) 36(d)",
    "5": "(c3) 1(f) 2(d) 3(f) 42(df) M4(h) 5(hg) 6(f) 7(h) 8(h) 9(,) 10(h) m11(h) m12(hi) 13(f) 14(e) M15(f) 16(e) 17(d) 18(e) 19(ef) M20(d) 21(d)",
    "6": "(c4) 1(f) 2(g) 22(gh) M3(h) 4(f) m5(gh) 25(ghg) 6(g) M7(fe) 8(d) 27(fvED) M9(f) 10(g) 11(g) 12(f) 30(fg) 31(gf)",
    "7": "(c3) 1(i) 2(g) 31(ig) 3(h) M4(ij) 5(i) 91(ih/ji) 6(,) 7(i) 8(j) 9(i) 10(h) 11(i) 92(i!jwk) 12(ih) 13(ij) 14(j) 15(i) 95(hg!hih) 16(;) 17(i) m18(ij) 19(i) 20(h) 21(hg) 22(f) m23(gh) 24(f) M25(e) 26(de) 27(e) 00(::) 98(f!gwh) 99(f!gwhf)",
    "8a": "(c4) 1(h) 31(f) m2(fg) 3(g) 4(,) 5(g) 6(h) 7(g) 8(f) M9(gh) 10(h) 11(;) m12(h) 13(g) 14(h) 54(hj) 15(j) M16(ji) 17(hg) 51(g) 52(h) 53(i) M18(hi) 38(hih) 19(h) m20(g) 21(,) 22(g) 23(f) M24(gh) 25(h) M26(g)",
    "8b": "(c4) 1(g) M2(gj) 3(hg) 93(hvGF) m4(h) 5(gf) 6(g) 7(gh) M8(h) 11(;) m12(h) 13(g) 14(h) 54(hj) 15(j) M16(ji) 17(hg) M18(hi) 51(g) 52(h) 53(i) 38(hih) 48(h) 49(i) 19(h) m20(g) 21(,) 22(g) 23(f) M24(gh) 25(h) M26(g)",
    "8c": "(c4) 1(j) 2(jkj) 3(jij) 4(ij) 5(,) 6(h) 7(g) 8(f) M9(gh) 10(h) 11(;) m12(h) 13(g) 14(h) 54(hj) 15(j) M16(ji) 17(hg) 51(g) 52(h) 53(i) M18(hi) 38(hih) 19(h) m20(g) 21(,) 22(g) 23(f) M24(gh) 25(h) M26(g)",
};

export const LOHFAnts: React.FC<{}> = () => {
    const [selectedMode, setSelectedMode] = useState("1a");
    const [text, setText] = useState("");

    const symbolMap: Record<string, string> = {};
    let clef = "";
    MELODIES[selectedMode].split(" ").forEach((item, itemIndex) => {
        if (itemIndex === 0) {
            clef = item;
        } else {
            const parts = item.replace(/\)/g, "").split("(");
            symbolMap[parts[0].replace("M", "").replace("m", "")] = parts[1];
        }
    });

    let gabc = text;
    Object.keys(symbolMap)
        .sort((a, b) => b.length - a.length)
        .forEach((symbol) => {
            gabc = gabc.replaceAll(symbol, "(" + symbolMap[symbol] + ")");
        });
    gabc = clef + " " + gabc + " (::)";

    return (
        <div>
            <div style={{ display: "flex", flexDirection: "row" }}>
                {[
                    "1a",
                    "1b",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "7",
                    "8a",
                    "8b",
                    "8c",
                ].map((m) => (
                    <div
                        style={{
                            padding: 4,
                            backgroundColor:
                                m === selectedMode ? "silver" : "transparent",
                        }}
                        onClick={() => setSelectedMode(m)}
                    >
                        {m}
                    </div>
                ))}
            </div>
            <div>
                <EBChant
                    gabc={MELODIES[selectedMode]}
                    dropCap={false}
                    tone={selectedMode[0]}
                />
            </div>
            <div>
                <textarea
                    style={{ width: "100%", height: 100, fontSize: 20 }}
                    value={text}
                    onChange={(event) => setText(event.target.value)}
                />
            </div>
            <div>
                <EBChant gabc={gabc} dropCap={false} tone={selectedMode[0]} />
            </div>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                }}
            >
                <EBPlayButton
                    gabc={gabc}
                    tone={selectedMode[0]}
                    title="Play"
                    tweak={0}
                />
            </div>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                }}
            >
                <EBPlayButton
                    gabc={gabc}
                    tone={selectedMode[0]}
                    title="Intone"
                    tweak={0}
                    onlyIntone={true}
                />
            </div>
            <div>{gabc.includes("$") ? gabc : "ADD $"}</div>
        </div>
    );
};
